import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/**
 * お知らせ画面のメッセージ
 */
export interface IPortalMessage {
	messageID: string;
	startDateStr: string;
	title: string;
	messageList: string[];
}

/**
 * お知らせ画面のWhat's New
 */
export interface IPortalWhatsNew extends IPortalMessage {
	careerID: string;
	careerTypeID: number;
	classID: string;
	isBtnApply: number;
	isBtnResultApply: number;
	titleList: string[];
}

/**
 * お知らせ画面のeラーニング
 */
export interface IPortalELearning {
	aplType: number;
	careerID: string;
	classID: string;
	contentFlg: number;
	enqueteFlg: number;
	reportFlg: number;
	title: string;
	showStatus: string;
	showOpenStartDate: string;
	showOpenEndDate: string;
	progress: string;
	openStartDate: Date;
	openEndDate: Date;
	uncompletedCareers: string;
	unrepresentedCareerCnt: string;
}

/**
 * お知らせ画面の集合研修
 */
export interface IPortalGroupTraining {
	careerID: string;
	className: string;
	fromToDate: string;
	title: string;
	classRoom: string;
}

/**
 * お知らせ画面の通信教育
 */
export interface IPortalDistanceLearning {
	className: string;
	fromToDate: string;
	title: string;
}

/**
 * メッセージ設定アクションクリエータ
 */
export const setPortalMessages = actionCreator<{
	messages: IPortalMessage[];
}>('SET_PORTAL_MESSAGES');

/**
 * What's New設定アクションクリエータ
 */
export const setPortalWhatsNews = actionCreator<{
	whatsNews: IPortalWhatsNew[];
}>('SET_PORTAL_WHATS_NEWS');

/**
 * eラーニング設定アクションクリエータ
 */
export const setPortalELearnings = actionCreator<{
	eLearnings: IPortalELearning[];
}>('SET_PORTAL_ELEARNINGS');

/**
 * 集合研修設定アクションクリエータ
 */
export const setPortalGroupTraining = actionCreator<{
	groupTraining: IPortalGroupTraining[];
}>('SET_PORTAL_GROUP_TRAINING');



// WEBPACK FOOTER //
// ./src/actions/portal.ts